@if (src) {
  <div class="image-viewer" (click)="close()">
    <fa-icon (click)="close()" icon="times" class="circle-icon-btn close-btn t-30 force-white"></fa-icon>
    <img [src]="src" />
  </div>
}
